import React from 'react';
import './table.scss';
import { PropTypes } from 'prop-types';
import LoadingPlaceholder from 'components/loadingPlaceholder';

export const TableSenate = ({ data, cols, legend }) => {
  console.log('### data', data);
  if (!data?.length) {
    return <LoadingPlaceholder />;
  }

  return (
    <div className="table-datosContainer table-general-data">
      <div className="table-datosScroll">
        <div className="table-wrapper">
          {data.length !== 0 && (
            <table summary="Detalle">
              <thead>
                <tr>
                  <th className="candidato">Candidato</th>

                  <th className="porcentaje">%</th>
                  <th className="votos">Votos</th>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter(item => item.votes)
                  .map(item => (
                    <tr key={item.id}>
                      <td className="dato-nombre-representante">
                        <span
                          className="partido-color"
                          style={{
                            backgroundColor: item.partyColor
                          }}
                        />
                        <span className="representante">{item.name}</span>
                      </td>
                      <td className="dato-escanos dato-escanos--percent">
                        {item.votesPercent
                          ? Number(item.votesPercent).toLocaleString('es')
                          : '-'}
                      </td>
                      <td className="dato-escanos_votes">
                        {item.votesPercent
                          ? Number(item.votes).toLocaleString('de')
                          : '-'}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

TableSenate.propTypes = {
  data: PropTypes.array.isRequired,
  cols: PropTypes.array,
  legend: PropTypes.string
};

TableSenate.defaultProps = {
  legend: '',
  cols: [
    {
      label: '',
      key: 'partyAcronym',
      classHead: 'partido',
      classBody: 'dato-nombre-partido',
      showColor: true
    },
    {
      label: '% Votos',
      key: 'votesPercent',
      classHead: 'porcentaje',
      classBody: 'dato-escanos',
      map: data => Number(data).toLocaleString('es')
    },
    {
      label: 'Votos',
      key: 'votes',
      classHead: 'porcentaje',
      classBody: 'dato-escanos',
      map: data => Number(data).toLocaleString('es')
    }
  ]
};

export default TableSenate;
